<template>
  <div class="container">
        <div class="body">
          <div class="top_div" >
                <img v-if="feeCodeName.indexOf('联合办公')!==-1" class="top_div_icon"
                                src="../../assets/images/icon_bill_other.png" />
                <img v-else-if="feeCodeName.indexOf('电费')!==-1" class="top_div_icon"
                              src="../../assets/images/icon_bill_electric.png" />
                <img v-else-if="feeCodeName.indexOf('租金')!==-1" class="top_div_icon"
                              src="../../assets/images/icon_bill_rent.png" />
                <img v-else-if="feeCodeName.indexOf('水费')!==-1" class="top_div_icon"
                              src="../../assets/images/icon_bill_water.png" />
                <img v-else-if="feeCodeName.indexOf('物业')!==-1" class="top_div_icon"
                              src="../../assets/images/icon_bill_property.png" />
                <img v-else class="top_div_icon"
                              src="../../assets/images/icon_bill_other.png" />
                <span class="top_div_span" >{{feeCodeName}}</span>
                <span v-if="freezeStatus==2" class="redSpan" >{{'冻结'}}</span>
          </div>
          <div class="gray_line"></div>
          <div class="body_info">
              <div class="body_info_item">
                <span class="body_info_item_span1">客户名称</span>
                <span class="body_info_item_span2">{{payerName}}</span>
              </div>
              <div class="body_info_item">
                <span class="body_info_item_span1">所属项目</span>
                <span class="body_info_item_span2">{{subProjectName}}</span>
              </div>
              <div class="body_info_item">
                <span class="body_info_item_span1">账单编号</span>
                <span class="body_info_item_span2">{{billCode}}</span>
              </div>
              <div class="body_info_item">
                <span class="body_info_item_span1">最迟缴款</span>
                <span class="body_info_item_span2">{{endDate}}</span>
              </div>
          </div>
          <div class="gray_line"></div>
          <div class="body_info">
              <div class="body_info_item">
                <span class="body_info_item_span1">合同编号</span>
                <span class="body_info_item_span2">{{contCode}}</span>
              </div>
              <div class="body_info_item">
                <span class="body_info_item_span1">费用期间</span>
                <span class="body_info_item_span2">{{startDate+'-'+billEndDate}}</span>
              </div>
               <div class="body_info_item">
                <span class="body_info_item_span1">房号</span>
                <span class="body_info_item_span2">{{spaceName}}</span>
              </div>
               <div class="body_info_item">
                <span class="body_info_item_span1">面积</span>
                <span class="body_info_item_span2">{{leasedArea}}{{leasedArea?'  ㎡':''}}</span>
              </div>
          </div>
          <div class="body_info1">
              <div class="body_info_item">
                  <span class="body_info_item_span1">账单应缴</span>
                  <span class="body_info_item_span21">{{planAmount}}元</span>
                  <span class="body_info_item_span11">已缴金额</span>
                  <span class="body_info_item_span21">{{realAmount}}元</span>
              </div>
              <div class="body_info_item">
                  <span class="body_info_item_span1">待缴金额</span>
                  <span class="body_info_item_span21">{{needPayAmount}}元</span>
                  <span class="body_info_item_span11">违约金</span>
                  <span class="body_info_item_span21">{{waiverAmount}}元</span>
              </div>
          </div>
          <div v-for="(item,index) in prpMeterPageBeanList" :key="index" class="body_info1">
               <div v-if="!item.lastReadNumberJ && !item.currentReadNumberJ" class="body_info11">
                <!-- <div class="body_info_item">
                  <span class="body_info_item_span1">费用期间</span>
                  <span class="body_info_item_span2">{{startDate+'-'+billEndDate}}</span>
                </div> -->
                  <div class="body_info_item">
                    <span class="body_info_item_span1">设备名称</span>
                    <span class="body_info_item_span2">{{item.deviceName}}</span>
                  </div>
                  <div class="body_info_item">
                    <span class="body_info_item_span1">上期读数</span>
                    <span class="body_info_item_span21">{{item.lastReadNumber}}</span>
                    <span class="body_info_item_span11">上期抄录日期</span>
                    <span class="body_info_item_span21">{{item.lastMeterDate}}</span>
                  </div>
                  <div class="body_info_item">
                    <span class="body_info_item_span1">本期读数</span>
                    <span class="body_info_item_span21">{{item.currentReadNumber}}</span>
                    <span class="body_info_item_span11">本期抄录日期</span>
                    <span class="body_info_item_span21">{{item.currentReadDate}}</span>
                  </div>
                  <div class="body_info_item">
                      <span class="body_info_item_span1">用量</span>
                      <span class="body_info_item_span21">{{item.usedNumber}}</span>
                      
                      <span v-if="feeCodeName == item.feeCodeName" class="body_info_item_span11">单价(元)</span>
                      <span v-else class="body_info_item_span11"> {{item  | unitPriceTypeName(feeCodeName) }}</span>   
                      <span v-if="feeCodeName == item.feeCodeName" class="body_info_item_span21">{{item.unitPrice}}</span>
                      <span v-else class="body_info_item_span21">{{item | unitPriceFilter(feeCodeName)}}</span>
                  </div>
               </div>
               <div v-else class="body_info11">
                <div class="body_info_item">
                  <span class="body_info_item_span1">设备名称</span>
                  <span class="body_info_item_span2">{{item.deviceName}}</span>
                </div>
                 <div class="body_info_item">
                    <span class="body_info_item_span1">上期读数(尖)</span>
                    <span class="body_info_item_span21">{{item.lastReadNumberJ}}</span>
                    <span class="body_info_item_span11">本期读数(尖)</span>
                    <span class="body_info_item_span21">{{item.currentReadNumberJ}}</span>
                  </div>
                   <div class="body_info_item">
                    <span class="body_info_item_span1">上期读数(峰)</span>
                    <span class="body_info_item_span21">{{item.lastReadNumberF}}</span>
                    <span class="body_info_item_span11">本期读数(峰)</span>
                    <span class="body_info_item_span21">{{item.currentReadNumberF}}</span>
                  </div>
                   <div class="body_info_item">
                    <span class="body_info_item_span1">上期读数(平)</span>
                    <span class="body_info_item_span21">{{item.lastReadNumberP}}</span>
                    <span class="body_info_item_span11">本期读数(平)</span>
                    <span class="body_info_item_span21">{{item.currentReadNumberP}}</span>
                  </div>
                   <div class="body_info_item">
                    <span class="body_info_item_span1">上期读数(谷)</span>
                    <span class="body_info_item_span21">{{item.lastReadNumberG}}</span>
                    <span class="body_info_item_span11">本期读数(谷)</span>
                    <span class="body_info_item_span21">{{item.currentReadNumberG}}</span>
                  </div>
                   <div class="body_info_item">
                    <span class="body_info_item_span1">上期抄录日期</span>
                    <span class="body_info_item_span21">{{item.lastMeterDate}}</span>
                    <span class="body_info_item_span11">本期抄录日期</span>
                    <span class="body_info_item_span21">{{item.currentReadDate}}</span>
                  </div>
                   <!-- <div class="body_info_item">
                    <span class="body_info_item_span1">用量(尖峰平谷)</span>
                    <span class="body_info_item_span21">{{item.currentReadNumberJ-item.lastReadNumberJ}}/{{item.currentReadNumberF-item.lastReadNumberF}}/{{item.currentReadNumberP-item.lastReadNumberP}}/{{item.currentReadNumberG-item.lastReadNumberG}}</span>
                    <span class="body_info_item_span11">单价(尖峰平谷)</span>
                    <span class="body_info_item_span21">{{item.unitPriceJ}}/{{item.unitPriceF}}/{{item.unitPriceP}}/{{item.unitPriceG}}</span>
                  </div> -->
                  <template v-if="feeCodeName == item.feeCodeName">
                    <div class="body_info_item">
                      <span class="body_info_item_span1">用量(尖)</span>
                      <!-- <span class="body_info_item_span21">{{item.currentReadNumberJ-item.lastReadNumberJ}}</span> -->
                      <span class="body_info_item_span21">{{item | readNumberJ}}</span>
                      <span class="body_info_item_span11">单价(尖)</span>
                      <span class="body_info_item_span21">{{item.unitPriceJ}}</span>
                    </div>
                    <div class="body_info_item">
                      <span class="body_info_item_span1">用量(峰)</span>
                      <span class="body_info_item_span21">{{item | readNumberF}}</span>
                      <span class="body_info_item_span11">单价(峰)</span>
                      <span class="body_info_item_span21">{{item.unitPriceF}}</span>
                    </div>
                    <div class="body_info_item">
                      <span class="body_info_item_span1">用量(平)</span>
                      <span class="body_info_item_span21">{{item | readNumberP}}</span>
                      <span class="body_info_item_span11">单价(平)</span>
                      <span class="body_info_item_span21">{{item.unitPriceP}}</span>
                    </div>
                    <div class="body_info_item">
                      <span class="body_info_item_span1">用量(谷)</span>
                      <span class="body_info_item_span21">{{item | readNumberG}}</span>
                      <span class="body_info_item_span11">单价(谷)</span>
                      <span class="body_info_item_span21">{{item.unitPriceG}}</span>
                    </div>
                  </template>
                  <template v-else> 
                    <div class="body_info_item">
                      <span class="body_info_item_span1">用量(尖)</span>
                      <span class="body_info_item_span21">{{item | readNumberJ}}</span>
                      <span class="body_info_item_span11">用量(峰)</span>
                      <span class="body_info_item_span21">{{item | readNumberF}}</span>
                    </div>
                    <div class="body_info_item">
                      <span class="body_info_item_span1">用量(平)</span>
                      <span class="body_info_item_span21">{{item | readNumberP}}</span>
                      <span class="body_info_item_span11">用量(谷)</span>
                      <span class="body_info_item_span21">{{item | readNumberG}}</span>
                    </div>
                    <div class="body_info_item">
                      <span class="body_info_item_span1">{{item  | unitPriceTypeName(feeCodeName) }}</span>
                      <span class="body_info_item_span21">{{item | unitPriceFilter(feeCodeName)}}</span>
                      <span class="body_info_item_span11"></span>
                      <span class="body_info_item_span21"></span>
                    </div>
                  </template>

               </div>
               
          </div>
           <div class="body_info1">
                  <span class="body_info_item_span">发票信息</span>
                  <div v-for="item in invoiceList " class="body_info_item" :key="item.id">

                    <span @click="goToPDF(item)" class="body_info_pdfspan">{{item.invoiceNo}}.pdf</span>
                  </div>

            </div>

        </div>

      <div class="foot" v-if="settleStatus!=1">
            <div class="foot_left">
                <span class="foot_span1">账单待缴金额：</span>
                <span class="foot_span2">¥{{needPayAmount}}</span>
            </div>
             <div v-if="freezeStatus!=2" class="foot_right button" @click="insertAccountOrder">
                <span :class="$store.state.common.theme !=3 ? 'foot_span3 btn_default' : 'foot_span3 btn_default btn_color_chang'">立即支付</span>
            </div>
            <div v-else class="foot_right">
              <span class="foot_span4 btn_default">立即支付</span>
            </div>
      </div>

  </div>
</template>
<script>

import { insertAccountOrder ,getInvoiceIssueDataByBillId,getOrderByOrderNo} from "../../utils/api";
import {serversHttp} from '../../utils/api.js';
import util from "../../utils/util";
import ping from '../../utils/pingpay.js'
import { mapState } from 'vuex';
import storage from '../../utils/storage';
export default {
  name: "billDetail",
  components: {},
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  filters: {
      formatTime(val){
          if(!val ||val ==undefined ||val==null){
              return ""
          }
        return util.formatTime(new Date(val),6);
      },
      formatYM(val){
         if(!val ||val ==undefined ||val==null){
              return ""
         }
        return util.formatTime(new Date(val),66);
      }
  },
  data() {
    return {
        timeInter:"",
        orderNo:'',
        canPay:true,
        //数据相关
        costAmount:0,
        contCode:"",
        subProjectName:'',
        endDate:'',
        billEndDate:'',
        settleStatus:'',
        billCode:'',
        feeCodeName:'',
        realAmount:'',
        checkStatus:'',
        reqStatus:'',
        feeCode:'',
        subProjectId:'',
        payerName:'',
        needPayAmount:'',
        waiverAmount:'',
        id:'',
        startDate:'',
        planAmount:'',
        receiptId:'',
        spaceName:'',
        leasedArea:'',
        prpMeterPageBeanList:[],
        prpMeterType:1,
        invoiceList:[],
        freezeStatus:'',  //冻结状态

    }
  },
  created(){
      //"contCode":"HT-201909-000031","subProjectName":"鲁能国际","endDate":"2019.08.17",
      //"settleStatus":2,"billCode":"AC-201909-000642","feeCodeName":"电费",
     // "realAmount":0.0,"checkStatus":false,"reqStatus":true,
     //"feeCode":"602","subProjectId":2,"payerName":"上海彬彬科技有限公司",
     //"needPayAmount":1000.0,"id":3612,"startDate":"2019.09.17","planAmount":1000.0
    //  var  query = this.$route.query;
     var  query = ''
     var str=  storage.getS('billDetailString');
     console.log("billDetailString  " + str)
     if(str){
       query = JSON.parse(str)
     }

      if(query.contCode && query.contCode!=undefined){
        this.contCode=query.contCode;
        if(this.contCode=="undefined"){
           this.contCode="";
        }
      }else{
        this.contCode="";
      }
      this.subProjectName=query.subProjectName;
      this.endDate =query.endDate;
      this.billEndDate =query.billEndDate;
      this.settleStatus =query.settleStatus;
      this.billCode =query.billCode;
      this.feeCodeName=query.feeCodeName || '';


      this.checkStatus=query.checkStatus;
      this.reqStatus=query.reqStatus;
      this.feeCode=query.feeCode;
      this.subProjectId=query.subProjectId;
      this.payerName=query.payerName;
      this.receiptId = query.receiptId;

      this.id=query.id;
      // this.startDate=query.startDate;
       this.startDate=query.billStartDate;

      console.log("this.receiptId =======    " + this.receiptId)

      if(query.needPayAmount){
        this.needPayAmount=parseFloat(query.needPayAmount) ;
      }else{
        this.needPayAmount=0
      }
      if(query.realAmount){
          this.realAmount=parseFloat(query.realAmount);
      }else{
        this.realAmount=0
      }
      if(query.planAmount){
         this.planAmount=parseFloat(query.planAmount);
      }else{
        this.planAmount= 0
      }
      if(query.waiverAmount && query.waiverAmount!=undefined){
        this.waiverAmount=parseFloat(query.waiverAmount);
      }else{
         this.waiverAmount= 0
      }
      // if(this.realAmount){
      //    this.realAmount=this.realAmount.toFixed(2);
      // }
      // if(this.needPayAmount){
      //    this.needPayAmount=this.needPayAmount.toFixed(2);
      // }

      if(this.planAmount){
         this.planAmount=this.planAmount.toFixed(2);
      }
      if(this.waiverAmount){
         this.waiverAmount=this.waiverAmount.toFixed(2);
      }
      this.spaceName = query.spaceNames
      this.leasedArea =query.realArea
      this.prpMeterPageBeanList =query.prpMeterPageBeanList

      this.freezeStatus =query.freezeStatus
      this.getInvoiceList();

  },
  destroyed(){
     clearInterval(this.timeInter);
  },

   activated () {
      //let query = this.$route.query;
      // this.arrearsNo = query.id
      // this.projectId =query.projectId
      // this.getBillDetails();
  },
  methods: {
    //上拉
     loadup(){

     },

     //下拉刷新
     loadData(){

     },
      getInvoiceList(){
        var params = {
          billId: this.id //342318 
        }
        getInvoiceIssueDataByBillId(params).then(res => {
           var list =[]
            if(res.res.code==10000 && res.body){
              var list1 = res.body;
              for(var i=0;i<list1.length;i++){
                 var item = list1[i];
                 for(var j=0;j<item.finInvoiceIssueBeanList.length;j++){
                     var jItem = item.finInvoiceIssueBeanList[j];
                     jItem.purchaser = item.purchaser;
                     jItem.purchaserTaxpayerNumber = item.purchaserTaxpayerNumber;
                     jItem.invoiceTime = item.invoiceTime;
                     
                     list.push(jItem)
                 }
              }
            }
            this.invoiceList = list;
            console.log(list)
          
        })
       
     },

    //生成订单
     insertAccountOrder(){
       if(this.orderNo){
         this.payAction();
         return;
       }
      let params = {
        'id':String(this.id) ,
        "billCode": this.billCode,
        "realAmount":this.realAmount,
        "needPayAmount": this.needPayAmount,
        "planAmount": this.planAmount,
        "waiverAmount": 0,
        "contCode": this.contCode,
        "marketId": String(this.subProjectId) ,
        "phone": this.common.userInfo.account,
        "createUser": this.common.userId,
        'createName': this.common.userTenantInfo.userName,
        'companyName': this.payerName,
        'accountCycle': this.billEndDate,
      }


      insertAccountOrder(params).then(ret => {
        console.log('in insertAccountOrderfinish')

        if (!ret.res) {

          return;
        }
        if (ret.res.code === 10000 && ret.body) {
          console.log('in insertAccountOrderfinish')
          this.orderNo = ret.body.orderNo
          this.payAction();
        //  self.showPayComponents = true
        } else {
         // toast.showMessage(ret.res.msg);
          util.showToast(ret.res.msg)
        }
      })

     },

     
      goToPDF(item){
            // item.purchaser =this.detail.purchaser
            // console.log(JSON.stringify(this.detail));
            console.log('purchaser === ' + item.purchaser )
            var url =serversHttp+ "servers.api/systemApi/exportFile?url="+encodeURIComponent(item.pdfUrl)
            console.log(url);
            localStorage.setItem("src", url);
            localStorage.setItem("srcFlie", item.pdfUrl);
            localStorage.setItem("srcFlieZDinfo", JSON.stringify(item));
          // 跳转地址
            this.$router.push(`/yulanpdf?invoiceId=`+item.id);

     },
     payAction(){
        if(!this.canPay){return;}
        this.canPay = false;
        let params = {
          orderNo: this.orderNo,
          repairNo: '', // "报修单号",
          bussinessType:"3",//会议室1,活动2,租赁账单3,物业报修4,保洁服务5,送水服务6
          // feeCode:this.feeCode,
          // feeName:this.feeCodeName,
          receiptId:this.receiptId,
          // payType: '5', // "支付类型 0微信，1支付宝, 4万生活, 5,ping++"
          channel: 'wx_pub' // 渠道名
        };
        this.startTimeInterval( this.orderNo,)
        ping(params, '', res => {
            console.log(res);
            setTimeout(() => {
              this.canPay = true;
              this.$router.go(-1);
            }, 1000);

          }, () => {
            setTimeout(() => {
              this.canPay = true;
              this.$router.go(-1);
            }, 1000);
          }, () => {
            setTimeout(() => {
              this.canPay = true;
              this.$router.go(-1);
            }, 1000);
          }
        );
        setTimeout(()=>{this.canPay = true},1000)
     },
     startTimeInterval(orderNo){
       var self = this
      //  if(self.timeInter){
          clearInterval(self.timeInter);
      //  }
       self.timeInter = setInterval(function () {
          self.getOrderByOrderNoAction(orderNo)
        }, 1500)

     },

     getOrderByOrderNoAction(orderNo){
       var that = this
        var params = {
          orderNo: orderNo
        }
        getOrderByOrderNo(params).then(res => {
           if(res.body){
             if(res.body.wxOperate ==2 || res.body.wxOperate == 3){
               clearInterval(this.timeInter);
               this.timeInter = null;
               this.canPay = true;
              if(res.body.wxOperate == 2){
                  this.pasSuccess()
                }else{
                  this.$router.go(-1);
                }

              }else 
              if(res.body.status == 2 || res.body.status == 3 || res.body.status == 1){
                clearInterval(this.timeInter);
                this.timeInter = null;
                this.canPay = true;
                // this.$router.go(-1);
                if(res.body.status == 2){
                  this.pasSuccess()
                }else{
                  this.$router.go(-1);
                }
                
             
              }
           }

        })

     },
     pasSuccess(){
        this.$router.replace('/BillSuccess')
     },







  },
  filters: {
    unitPriceFilter(item,feeCodeName){
      var str = item.unitPrice;
      var energySurchargeConfig = item.energySurchargeConfig;
      var list = JSON.parse(energySurchargeConfig);
      for(var i=0;i<list.length;i++){
        var item1 = list[i];
        if(item1.feeName==feeCodeName){
          str = item1.unitPrice;
          break;
        }
      }
      return str
        

    },
    unitPriceTypeName(item,feeCodeName){
      var sItem
      var energySurchargeConfig = item.energySurchargeConfig;
      var list = JSON.parse(energySurchargeConfig);
      for(var i=0;i<list.length;i++){
        var item1 = list[i];
        if(item1.feeName==feeCodeName){
          sItem = item1
          break;
        }
      }
      if(sItem && sItem.fixedAmount==1){
          return '总价(元)'
      }
      return '单价(元)'

    },
    readNumberJ(item){
      var num = util.minus(item.currentReadNumberJ, item.lastReadNumberJ)
      if(item.twices){
        num = util.multipliedBy(num, item.twices)
      }
      return num
    },
    readNumberF(item){
      var num = util.minus(item.currentReadNumberF, item.lastReadNumberF)
      if(item.twices){
        num = util.multipliedBy(num, item.twices)
      }
      return num
    },
    readNumberP(item){
      var num = util.minus(item.currentReadNumberP, item.lastReadNumberP)
      if(item.twices){
        num = util.multipliedBy(num, item.twices)
      }
      return num
    },
    readNumberG(item){
      var num = util.minus(item.currentReadNumberG, item.lastReadNumberG)
      if(item.twices){
        num = util.multipliedBy(num, item.twices)
      }
      return num
    },

  }
}

</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  // height: 100vh;
  position: relative;
  background-color: #EDEDED;
  .flex(column);
  .shop_list1 {
    flex: 1;
     height: 500px;
  }
}

.body{

  flex-direction: column;
  margin-bottom: 108px;

}
.viewbuttom{
    padding-bottom: 14px;
}

.top_div{
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 88px;
  background-color: #FFFFFF;
  align-items: center;
}

.top_div_icon{
    display: flex;
    margin-left: 32px;
    width: 44px;
    height: 44px;

}
.top_div_span{
    margin-left: 14px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.redSpan{
  margin-left: 20px;
  height:48px;
  font-size:28px;
  line-height:48px;
  padding-left: 10px;
  padding-right: 10px;

  background: #FFF2F0;
  color: red;
}

.gray_line{
  width: 100%;
  display: flex;
  height:2px;
  background:rgba(234,234,234,1);
}

.body_info{
  width: 100%;
  background-color: #FFFFFF;
  padding-top: 28px;
  padding-bottom: 8px;
  display: flex;
  flex-direction: column;
}
.body_info1{
  margin-top: 14px;
  width: 100%;
  background-color: #FFFFFF;
  padding-top: 28px;
  padding-bottom: 8px;
  display: flex;
  flex-direction: column;
}
.body_info11{
  width: 100%;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
}
.body_info_item{
    display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  align-items: center;
}
.body_info_item_span{
  margin-left: 28px;
  margin-bottom: 16px;
  width: 140px;
  display: flex;
  height:40px;
  font-size:28px;
  font-weight:400;
  color:rgba(0,0,0,1);
  line-height:40px;

}
.body_info_pdfspan{
  padding-left: 28px;
  padding-right: 28px;
  color: #0087ff;
  font-size:28px;
  line-height:40px;
}
.body_info_item_span1{
  margin-left: 28px;
  width: 160px;
  display: flex;
  font-size:24px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:40px;

}
.body_info_item_span11{
  width: 160px;
  display: flex;
  font-size:24px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:40px;

}

.body_info_item_span2{
  font-size:24px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:40px;

}

.body_info_item_span21{
  margin-left: 7rpx;
  width: 180px;
  display: flex;
  font-size:24px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:40px;

}


.top_div_item1{
   padding-top: 10px;
   margin-left: 28px;
   display: flex;
   width: 694px;
   flex-direction:row;
}

.top_div_span1{
  width: 140px;
  font-size:24px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:34px;
  display: flex
}


.top_div_span2{
  width: 207px;
  word-break: break-all;
  font-size:24px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:34px;
  display: flex
}
.top_div_span3{
  width: 124px;
  font-size:24px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:34px;
  display: flex
}

.top_div_span4{
  width: 223px;
  font-size:24px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:34px;
  display: flex
}

.top_div_span11{
  width: 694px;
  height:34px;
  font-size:24px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:34px;
  display: flex
}

.top_div_span12{
  width: 526px;
  height:34px;
  font-size:24px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:34px;
  display: flex
}


//list cell
.list_cell{
    width: 100%;
    height: 270px;
    background-color: #ffffff;
    flex-direction: column;
    display: flex;
    margin-bottom: 14px;
}

.list_item_top{
    width: 100%;
    height: 88px;
    border-bottom-width: 1px;
    border-bottom-color: #EAEAEA;
    border-bottom-style: solid;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.list_item_top_left{
    margin-left: 26px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}
.list_item_top_icon{
    display: flex;
    width: 44px;
    height: 44px;

}
.list_item_top_span1{
    margin-left: 14px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}

.list_item_top_line{
    margin-left: 14px;
    width:2px;
    height:28px;
    display: flex;
    background-color: #DADADA;
}
.list_item_top_span2{
    margin-left: 14px;
    word-break: break-all;
    font-size:28px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:40px;
}
.list_item_top_right{
    margin-right: 28px;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

}

.list_item_top_span3{
    height:40px;
    font-size:28px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:40px;

}


.list_item_body_item1{
   margin-top: 20px;
   margin-left: 28px;
   display: flex;
   width: 694px;
   flex-direction:row;

}
.list_item_body_span1{
  width: 124px;
  height:34px;
  font-size:24px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:34px;
  display: flex
}
.list_item_body_span2{
  width: 223px;
  word-break: break-all;
  font-size:24px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:34px;
  display: flex
}

.list_item_body_span12{
  width: 570px;
  height:34px;
  font-size:24px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:34px;
  display: flex
}
.list_item_bottom{
  width: 100%;
  display: flex;
  flex-direction: column;
//   padding-bottom: 28px;

}

//foot
.foot{
    width: 100%;
    position:fixed;
    left: 0;
    bottom: 0;
    height: 108px;
    background-color: #ffffff;
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.foot_left{
    margin-left: 28px;
    justify-content: flex-start;
    align-items: center;
}
.foot_span1{
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.foot_span2{
    height:44px;
    font-size:32px;
    font-weight:500;
    color:rgba(252,63,86,1);
    line-height:44px;
}

.foot_right{
     margin-right: 28px;
     justify-content: flex-end;
     align-items: center;
}
.foot_span3{

    width:192px;
    height:68px;
    display: block;
    text-align: center;
    background:rgba(23,64,218,1);
    border-radius:4px;
    font-size:28px;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height: 68px;

}
.btn_color_chang{
  background:#A1805D;
}
.foot_span4{

width:192px;
height:68px;
display: block;
text-align: center;
background:#c9c9c9;
border-radius:4px;
font-size:28px;
font-weight:400;
color:rgba(255,255,255,1);
line-height: 68px;

}


</style>